/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TipoTransazioneVoucher } from './tipo-transazione-voucher';


export interface TransazioneVoucherListFilter { 
    id_negozio?: string;
    id_tipo_pratica?: string;
    tipo_transazione?: TipoTransazioneVoucher;
}



